import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';

import {
  getCompleteData,
  getItems,
  getYears,
  searchPart,
} from '../../../actions/HomeAction';
import Axios from '../../../axios/axios';
import { toast } from 'react-toastify';
import Spinner from '../../Loader/Spinner';


export const SeachSection = ({ initialFilters = {} }) => {
  const [spareModels, setSpareModels] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(initialFilters.categoryId || "");
  const [selectedBrand, setSelectedBrand] = useState(initialFilters.brandId || "");
  const [selectedModel, setSelectedModel] = useState(initialFilters.modelId || "");
  const [selectedYear, setSelectedYear] = useState(initialFilters.year || "");
  const [selectedRegion, setSelectedRegion] = useState(initialFilters.regionId || "");

  const [loading, setLoading] = useState(false);



  const navigate = useNavigate();

  // Fetch initial data
  useEffect(() => {
    getCompleteData(setSpareModels, setSpareBrand, setSpareCategory);
    getItems(setRegion);
    setYears(getYears());
    getModelData(initialFilters.brandId || "");
  }, []);

  // Fetch models for selected brand
  const getModelData = async (brandId = selectedBrand) => {
    if (!brandId) {
      setSpareModels([]);
      setSelectedModel(""); // reset model if brand cleared
      return;
    }
    try {
      const res = await Axios.post("/model/modelBybrand", { brand: brandId });
      setSpareModels(res.data);

      // Set model if initialFilters.modelId exists in new models
      if (initialFilters.modelId) {
        const exists = res.data.some((m) => m._id === initialFilters.modelId);
        if (exists) setSelectedModel(initialFilters.modelId);
      }
    } catch (error) {
      console.error(error);
      setSpareModels([]);
    }
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const handleSearch = async () => {


    const filters = {};
    if (selectedCategory) filters.categoryId = selectedCategory;
    if (selectedBrand) filters.brandId = selectedBrand;
    if (selectedModel) filters.modelId = selectedModel;
    if (selectedYear) filters.year = selectedYear;
    if (selectedRegion) filters.regionId = selectedRegion;

    if (Object.keys(filters).length === 0) {
      toast.warning('Please select at least one filter.', {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setLoading(true)



    try {
      const parts = await searchPart(filters);
      const searchParams = new URLSearchParams(filters).toString();
      navigate(`/category?${searchParams}`, {
        state: {
          spareCategory,
          spareBrand,
          spareModels,
          region,
          years,
        },
      });
      setLoading(false)
    } catch (error) {
      console.error("Error fetching parts:", error);
      alert("An error occurred while fetching parts. Please try again.");
    }
  };

  const style = {
    fontFamily: "Poppins', sans-serif",
    position: "relative",
    fontWeight: 1000,
    color: "#353C4B",
    fontSize: "104px !important",
  };




  console.log(spareBrand, 'spareBrandspareBrandspareBrand');
  
  const hasSelectedFilters = !!(selectedCategory || selectedBrand || selectedModel || selectedYear || selectedRegion);

  const handleClearFilters = () => {
    setSelectedCategory("");
    setSelectedBrand("");
    setSelectedModel("");
    setSelectedYear("");
    setSelectedRegion("");
    setSpareModels([]);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: 50,
      minHeight: 50,
      borderRadius: 6,
      borderColor: "#ccc",
      backgroundColor: "#fff",
      paddingLeft: 4,
      fontFamily: "Poppins, sans-serif",
      fontSize: 15,
      boxShadow: state.isFocused ? "0 0 0 2px rgba(30,99,216,0.2)" : "none",
      "&:hover": { borderColor: "#ccc" },
    }),

    menu: (base) => ({
      ...base,
      marginTop: 2,
      borderRadius: 6,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      zIndex: 99999,
      backgroundColor: "#fff",
      position: "absolute",
    }),

    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: 200,
    }),

    option: (base, state) => ({
      ...base,
      padding: "10px 12px",
      fontSize: 15,
      backgroundColor: state.isSelected
        ? "#efefef"
        : state.isFocused
        ? "#f3f4f6"
        : "#ffffff",
      color: "#374151",
      cursor: "pointer",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#374151",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#6b7280",
      paddingRight: 12,
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    valueContainer: (base) => ({
      ...base,
      paddingLeft: 4,
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  };

  return (

    <section id="banner" style={{ width: '100%', }}>
      <div className="banner" style={{ ...sectionStyle, width: '100%', }}>
        <div className="container-fluid d-flex flex-column align-items-center justify-content-center text-center search-part-section"  >
          <div className="bnr-div" style={{ width: '100%', }}>
            <div className="row no-gutters">
              <div className="col-lg-6 offset-lg-3" style={style}>
                <h1 className="text-uppercase text-center">
                  Find Part by Vehicle
                </h1>
                <p>
                  Whether you're a professional mechanic or a car enthusiast,
                  finding the right part for your vehicle has never been easier.
                  Use our precise search tool to locate the exact spare part you
                  need.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">

                        <div className="col-12 col-md-2 mb-2">
            <Select
              isClearable
              isSearchable
              options={(spareCategory || []).map((c) => ({
                value: c._id,
                label: c.name,
              }))}
              value={
                (spareCategory || [])
                  .map((c) => ({ value: c._id, label: c.name }))
                  .find((c) => c.value === selectedCategory) || null
              }
              onChange={(opt) => setSelectedCategory(opt ? opt.value : "")}
              placeholder="Category"
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </div>

          {/* Brand */}
              <div className="col-12 col-md-2 mb-2">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder="Brand"
                  value={spareBrand.find((b) => b.value === selectedBrand) || null}
                  onChange={(selectedOption) => {
                    const brandId = selectedOption ? selectedOption.value : "";
                    setSelectedBrand(brandId);
                    getModelData(brandId);
                  }}
                  options={spareBrand}
                  isClearable
                  styles={{

                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
              </div>

              {/* Model */}
              <div className="col-12 col-md-2 mb-2">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder="Model"
                  value={
                    spareModels
                      .map((m) => ({ value: m._id, label: m.name }))
                      .find((m) => m.value === selectedModel) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedModel(selectedOption ? selectedOption.value : "")
                  }
                  options={spareModels.map((m) => ({ value: m._id, label: m.name }))}
                  isClearable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#adb5bd" },
                      minHeight: "38px",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
              </div>

              {/* Year */}
              <div className="col-12 col-md-2 mb-2">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder="Year"
                  value={
                    years
                      .map((y) => ({ value: y, label: y }))
                      .find((y) => y.value === selectedYear) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedYear(selectedOption ? selectedOption.value : "")
                  }
                  options={years.map((y) => ({ value: y, label: y }))}
                  isClearable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#adb5bd" },
                      minHeight: "38px",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
              </div>

              {/* Region */}
              <div className="col-12 col-md-2 mb-2">
                <Select
                  className="basic-single w-100"
                  classNamePrefix="select"
                  placeholder="Region"
                  value={
                    region
                      .map((r) => ({ value: r._id, label: r.name }))
                      .find((r) => r.value === selectedRegion) || null
                  }
                  onChange={(selectedOption) =>
                    setSelectedRegion(selectedOption ? selectedOption.value : "")
                  }
                  options={region.map((r) => ({ value: r._id, label: r.name }))}
                  isClearable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ced4da",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#adb5bd" },
                      minHeight: "38px",
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                  }}
                />
              </div>

              {/* Search Button */}
              <div className="col-12 col-md-2 mb-2 d-flex gap-2">
                <button
                  type="button"
                  className="form-control text-white"
                  style={{
                    backgroundColor: '#db0505ff',
                    borderRadius: '0.25rem',
                    border: '5px solid #db0505ff',
                    flex: '1 1 auto',
                  }}
                  onClick={handleSearch}
                >
                  <i className="fa fa-search" aria-hidden="true"></i>
                  &nbsp;&nbsp;Search
                </button>
                {hasSelectedFilters && (
                  <button
                    type="button"
                    className="btn btn-outline-danger fw-bold"
                    style={{ whiteSpace: "nowrap", height: "100%", borderRadius: "0.25rem" }}
                    onClick={handleClearFilters}
                    title="Clear selected search filters"
                  >
                    ✕ Clear
                  </button>
                )}
              </div>
              {loading && <Spinner />}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
